const clearShoppingListCache = (client) => {
  const serializedState = client.cache.extract();
  const userId = Object.values(serializedState).filter((item) => item.__typename === 'Me')[0].id;
  const meObject = serializedState[`Me:${userId}`];
  const shoppingListKeys = Object.keys(meObject).filter((item) => item.includes('shoppingList'));

  shoppingListKeys.forEach((key) => {
    client.cache.evict({
      id: `Me:${userId}`,
      fieldName: key,
    });
  });

  client.cache.gc();
};

export default clearShoppingListCache;
